import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import styles from './styles.module.scss'

export function NotEligibleSSOUser() {
  const { t } = useTranslation()

  useEffect(() => {
    localStorage.removeItem('ssoEmail')
    localStorage.removeItem('ssoOrgId')
  }, [])

  return (
    <PageContainer pageTitle={t('notEligibleSSO.title')} withHeader={true} withFooter={false} isPlainBanner={true}>
      <div className={styles.container}>
        <img src={`${config.assetUrl + '/images/Oops.png'}`} alt='' className={styles.img} />
        <h1 className={styles.title}>{t('notEligibleSSO.title')}</h1>
        <h2 className={styles.subtitle}>{t('notEligibleSSO.subTitle')}</h2>
      </div>
    </PageContainer>
  )
}
